import { render, staticRenderFns } from "./couseDetail.vue?vue&type=template&id=b466f766&scoped=true"
import script from "./couseDetail.vue?vue&type=script&lang=js"
export * from "./couseDetail.vue?vue&type=script&lang=js"
import style0 from "./couseDetail.vue?vue&type=style&index=0&id=b466f766&prod&scoped=true&lang=css"
import style1 from "./couseDetail.vue?vue&type=style&index=1&id=b466f766&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b466f766",
  null
  
)

export default component.exports